export const beerVarieties = [
    "lager",
    "pale",
    "ipa",
    "west coast",
    "neipa",
    "session",
    "table",
    "sour",
    "stout",
    "porter",
    "fruited",
    "mixed fermentation",
    "german",
    "belgian",
    "weissbier",
    "berlinerweisse",
    "hefeweizen",
    "radler",
    "bitter",
    "mild",
];
export const spiritVarieties = [
    "spirit",
    "whisky",
    "whiskey",
    "gin",
    "vodka",
    "rum",
    "rtd",
    "cocktails",
];
export const softVarieties = ["soda", "juice", "kombucha"];
export const wineVarieties = ["red", "white", "rosé", "sparkling"];
const styleSearchStrings = {
    beer: ["beer", ...beerVarieties].join("|"),
    cider: "cider",
    spirits: spiritVarieties.join("|"),
    softDrinks: softVarieties.join("|"),
    wine: "wine",
    mead: "mead",
};
export const getProductStyleSearchString = (style) => {
    return styleSearchStrings[style];
};
//# sourceMappingURL=getProductStyleSearchString.js.map